export enum WIDGET_LINKS {
    /**
     * @value Add link
     * @description This is the title of a dialog box that gives the possibility to add link to images.
     */
    ADD_LINK = 'LUMX.LINK_DIALOG_ADD_TITLE',
    /**
     * @value Open link in a new window
     */
    ADD_TARGET_BLANK = 'WIDGET_TYPE_LINKS_ADD_TARGET_BLANK',
    /**
     * @value Link configuration
     */
    DIALOG_TITLE = 'WIDGET_TYPE_LINKS_MODAL',
    /**
     * @value Upload thumbnail picture
     */
    LINKS_THUMBNAIL_UPLOAD = 'WIDGET_TYPE_LINKS_THUMBNAIL_UPLOAD',
    /**
     * @value Link options
     * @description Display the title of the widget-link edition dialog
     */
    LINKS_WIDGET_SETTINGS_TITLE = 'DESIGNER.LINKS_WIDGET_SETTINGS_TITLE',
    /**
     * @value No links yet
     * @description Information displayed in the placeholder of the widget links settings.
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'WIDGET_LINKS_SETTINGS.NO_LINKS_TITLE',
}
